import {useEffect, useRef} from "react";

export default function UpdatableVideo({ url, sourceType = "video/mp4", ...otherProps }) {
    const videoRef = useRef();

    useEffect(() => {
        videoRef.current?.load();
    }, [url]);

    return (
        <video
            ref={videoRef}
            {...otherProps}
        >
            <source src={url} type={sourceType} />
            مرورگر شما از ویدیو پشتیبانی نمی کند
        </video>
    );
}
